import { useMedia as useMediaReact } from 'react-use';
import { useStyletron, type Theme } from '@olxeu-jobs/ui';
import { useIsMobilePlatform } from './use-is-mobile-platform';

const MOBILE_KEYS: Array<keyof Theme['mediaQuery']> = ['xs', 'sm', 'touch'];

// TODO: move to lib
export const useMedia = (...keys: Array<keyof Theme['mediaQuery']>) => {
  const [, theme] = useStyletron();
  const isMobilePlatform = useIsMobilePlatform();
  const defaultState = isMobilePlatform
    ? MOBILE_KEYS.some((key) => keys.includes(key))
    : MOBILE_KEYS.every((key) => !keys.includes(key));
  const mediaQuery = keys.map((key) => theme.mediaQuery[key].replace(/@media\s/, '')).join(' and ');

  return useMediaReact(mediaQuery, defaultState);
};
